'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../../dist-es6/client/angularCommon/baseController');let

BaseUserProfileController=class BaseUserProfileController extends BaseController{
constructor(uncaughtErrorHandler,user){
super(uncaughtErrorHandler);
if(_.exists(user)){
this._firstName=user.firstName;
this._lastName=user.lastName;
this._email=user.email;
this._phone=user.phone;
}
}

get firstName(){return this._firstName}
get lastName(){return this._lastName}
get email(){return this._email}
get phone(){return this._phone}

set firstName(firstName){this._firstName=firstName}
set lastName(lastName){this._lastName=lastName}
set phone(phone){this._phone=phone}
set email(email){this._email=email}};


module.exports=BaseUserProfileController;
//# sourceMappingURL=baseUserProfileController.js.map
